import type { ComponentProps, ValidComponent } from "solid-js";
// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import { clsx } from "clsx/lite";

export type ClassValue = string | boolean | number | null | undefined;
type ClasslessComponentProps<C extends ValidComponent> = Omit<ComponentProps<C>, "class">;
export type ClassyComponentProps<C extends ValidComponent> = ClasslessComponentProps<C> & {
  class?: ClassValue;
};

export { clsx };
export default clsx as (...inputs: ClassValue[]) => string;
